module.exports = __webpack_public_path__ + "static/ART_Logo-usage_correct3-d9bfaba07dca22b691bf4dfb7bbdd321.svg";